export { default } from './LowestRatesPropertiesContainer';
